// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3vD8A","question":"Question_question__1rBFp","description":"Question_description__heJr8"};